import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";

const StoreContext = createContext(null);

export function StoreProvider({ children }) {
  const [products, setProducts] = useState([]);
  const [paymentConfig, setPaymentConfig] = useState({ demo: true, razorpay: false, paypal: false });
  const [cart, setCart] = useState(() => JSON.parse(localStorage.getItem("bkg-cart") || "[]"));

  const refreshProducts = async () => {
    const { data } = await api.get("/products");
    setProducts(data);
  };

  useEffect(() => {
    refreshProducts().catch(console.error);
    api.get("/payments/config").then(({ data }) => setPaymentConfig(data)).catch(console.error);
  }, []);

  useEffect(() => {
    localStorage.setItem("bkg-cart", JSON.stringify(cart));
  }, [cart]);

  const addToCart = (product, quantity = 1) => {
    setCart((items) => {
      const existing = items.find((item) => item.id === product.id);
      if (existing) {
        return items.map((item) => item.id === product.id ? { ...item, quantity: Math.min(item.quantity + quantity, 10) } : item);
      }
      return [...items, { ...product, quantity }];
    });
  };

  const updateQuantity = (id, delta) => {
    setCart((items) => items.map((item) => item.id === id ? { ...item, quantity: Math.max(1, item.quantity + delta) } : item));
  };

  const removeFromCart = (id) => setCart((items) => items.filter((item) => item.id !== id));
  const clearCart = () => setCart([]);

  const value = useMemo(() => ({
    products,
    cart,
    paymentConfig,
    refreshProducts,
    addToCart,
    updateQuantity,
    removeFromCart,
    clearCart,
    cartCount: cart.reduce((sum, item) => sum + item.quantity, 0),
    subtotal: cart.reduce((sum, item) => sum + item.price * item.quantity, 0),
  }), [products, cart, paymentConfig]);

  return <StoreContext.Provider value={value}>{children}</StoreContext.Provider>;
}

export const useStore = () => useContext(StoreContext);
